// extracted by mini-css-extract-plugin
module.exports = {"title":"SectorInfo_title__rU0lV","figure":"SectorInfo_figure__3G4UH"};